import { RaceBy } from "@uiball/loaders";
import { useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import modificarObservacion from "../../../services/adp/turn/modificar-observacion";
import Message from "../../../utils/message";

export function ModalEditarObservacion(props) {
    const { observacion, loader, setLoading, ver_modificar_observacion, datosTurno, setModificarObservacion, TOKEN, setLoader, obtenerDatosTurno } = props;

    const [observacion_m, setObservacionM] = useState(observacion);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const params = {
            observacion: observacion_m,
        }
        setLoader(true);
        setLoading(true);
        await modificarObservacion({
            id: datosTurno.turno_id, params: params, token: TOKEN, callbacks: async (response) => {
                if (response.estado > 0) {
                    await obtenerDatosTurno(datosTurno.turno_id);
                    await setModificarObservacion(false)
                    setObservacionM('');
                    setLoading(false);
                } else {
                    Message({ message: response.mensaje, type: 'error' })
                    setLoader(false);
                    setLoading(false);
                }
            }
        })
    }
    const cerrarPopup = async () => {
        setObservacionM('');
        await setModificarObservacion(false);
    }

    return (
        <>
            <div className={`modal ${!ver_modificar_observacion ? 'fade' : 'show d-block'}`} id="modalAgregarMotivoTurno" tabIndex="-1" aria-labelledby="modalAgregarMotivoTurnoLabel" aria-hidden="true">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6>Modificar observacion al turno #{datosTurno.motivo_turno_abreviacion} - {datosTurno.turno_id}</h6>
                            <button type="button" className="btn-close" id="modalDerivacionClose" onClick={cerrarPopup} aria-label="Close"></button>
                        </div>

                        <div className="modal-body">
                            {
                                loader &&
                                <RaceBy
                                    size={280}
                                    lineWeight={15}
                                    speed={1.4}
                                    color="black"
                                    className="d-flex"
                                />
                            }
                            {
                                !loader &&
                                <form id="formModificarObservacion" onSubmit={handleSubmit}>
                                    <div className="form-group my-1">
                                        <b>Turno:</b> #{datosTurno.motivo_turno_abreviacion} - {datosTurno.turno_id}
                                    </div>
                                    <div className="form-group my-1">
                                        <b>Fecha:</b> {datosTurno.fecha}
                                    </div>
                                    <div className="form-group my-1">
                                        <b>Hora:</b> {datosTurno.hora}
                                    </div>
                                    <div className="form-group my-5">
                                        <div className="container__form__observaciones">
                                            <FloatingLabel controlId="observaciones" label="Observaciones" className="mb-3" >
                                                <Form.Control as="textarea" placeholder="Indique observaciones" className="customArea" defaultValue={observacion} onChange={({ target }) => setObservacionM(target.value)} />
                                            </FloatingLabel>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <button className="btn btn-success mx-auto d-block my-2">Editar</button>
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}